import React, { memo } from 'react'
import FormStaticField from '@active/react-ui/FormStaticField'
import LinkButton from '@active/react-ui/LinkButton'
import { withI18n } from '@active/react-utils/i18n'

import I18nMessage from '../I18nMessage'

function StaticEmailWithEditButton({
  editAble,
  handleEdit,
}) {
  return (
    <div className="passport__checkemail passport__checkemail-static">
      <FormStaticField />
      {editAble && (
        <LinkButton tabIndex={0} className="passport__checkemail__change-btn" onClick={handleEdit}>
          <I18nMessage id="passport.signup.btn.change" />
        </LinkButton>
      )}
    </div>
  )
}

export default memo(withI18n(StaticEmailWithEditButton))
